import { inViewMargin } from '@helpers/animate';
import { useInView } from '@hooks/useInView';
import LinkButton from '@stories/Components/LinkButton/LinkButton';
import * as React from 'react';
import S from './TextListSection.styles';
const TextListSection = ({ bgColor = 'white', content, cta, id, list1, list2, title, }) => {
    const [refContainer, inView] = useInView({ rootMargin: inViewMargin });
    return (React.createElement(S.Container, { ref: refContainer, id: id, "data-bg": bgColor, "data-inview": inView, "data-single-list": list1 && !list2 },
        React.createElement(S.Inner, null,
            React.createElement(S.ContentWrapper, null,
                React.createElement(S.Title, { id: title.replaceAll(/[\W_]+/g, '-').toLowerCase() }, title),
                content && React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: content } })),
            cta && (React.createElement(S.CtaWrapper, null,
                React.createElement(LinkButton, { buttonType: bgColor === 'black' ? 'inverted' : 'default', href: cta.url, target: cta.target }, cta.text))),
            React.createElement(S.ListsWrapper, null,
                renderList(list1),
                list2 && renderList(list2)))));
    function renderList(list) {
        if (!list) {
            return null;
        }
        return (React.createElement(S.ListWrapper, null,
            list.title && React.createElement(S.ListTitle, null, list.title),
            React.createElement(S.List, null, list.items.map((item) => (React.createElement(S.Item, { key: item.id },
                React.createElement(S.Link, { as: item.url ? 'a' : 'span', href: item.url, target: item.target }, item.text)))))));
    }
};
export default TextListSection;
